/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：502
 */

var r = require(/* 1430 */"./1430")
var i = "object" == typeof self && self && self.Object === Object && self
var o = r || i || Function("return this")()
module.exports = o
